import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { Controller, FieldValues } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

export function FormSelectOne<T extends FieldValues>({
    control,
    disabled,
    helperText,
    label,
    options,
    required,
    small,
    value,
}: Readonly<BaseInputProps<T>>) {
    const selectOptions: Record<string, string | number>[] = options || [];

    return (
        <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Controller
                control={control}
                name={value}
                render={({ field: { onBlur, onChange, ref, value: optionValue }, fieldState: { error } }) => (
                    <>
                        <Select
                            disabled={disabled}
                            error={error?.message ? true : false}
                            label={label}
                            onBlur={onBlur}
                            onChange={onChange}
                            ref={ref}
                            size={small ? 'small' : 'medium'}
                            sx={{ minWidth: 250 }}
                            value={optionValue}
                        >
                            {selectOptions.length > 0 ? (
                                selectOptions.map((option) => (
                                    <MenuItem
                                        disabled={option.disabled as unknown as boolean}
                                        key={value + String(option.value ?? option.id ?? '')}
                                        value={option.value !== undefined ? option.value : option.id}
                                    >
                                        {option.label ?? option.id ?? ''}
                                    </MenuItem>
                                ))
                            ) : (
                                <Box
                                    sx={{
                                        p: 1,
                                        px: 2,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: 'text.secondary',
                                        }}
                                    >
                                        No Options
                                    </Typography>
                                </Box>
                            )}
                        </Select>
                        <FormHelperText sx={{ color: error?.message ? 'error.main' : 'initial' }}>
                            {error?.message ?? helperText}
                        </FormHelperText>
                    </>
                )}
                rules={{
                    required: required ? `${label ?? value} cannot be empty` : false,
                }}
            />
        </FormControl>
    );
}
